import { useMemo, Dispatch } from "react"
import { generateManuallyResolveFleetEntryDropdown } from "./ManuallyResolveFleetEntryDropdown"
import { ManuallyResolveEntriesAction } from "../../manuallyResolveEntriesReducer"
import { FilterVehicle } from "../../../../../../api/vehicles/filter"
import { AddedFleetEntry } from "../../../../../../api/fleet"
import { generateManuallyResolveFleetEntryConfirm } from "./ManuallyResolveFleetEntryConfirm"

export const MANUALLY_RESOLVE_ENTRY_FIELDS_DATA_TEST_IDS = {
  MAKE: `make`,
  MODEL: `model`,
  FUEL: `fuel`,
  TRIM: `trim`,
  CONFIRM: `confirm`,
}

type Hook = {
  Make: () => JSX.Element
  Model: () => JSX.Element
  Fuel: () => JSX.Element
  Confirm: () => JSX.Element
}

export const useManuallyResolveEntriesFields = (
  index: number,
  entries: ReadonlyArray<AddedFleetEntry>,
  dispatch: Dispatch<ManuallyResolveEntriesAction>
): Hook => {
  const entry = useMemo(() => entries[index], [entries, index])
  const Make = useMemo(
    () =>
      generateManuallyResolveFleetEntryDropdown({
        name: `make`,
        dataTestId: MANUALLY_RESOLVE_ENTRY_FIELDS_DATA_TEST_IDS.MAKE,
        entry,
        dataKey: `manufacturers`,
        prerequisiteFields: [],
        onChange: (value) => dispatch({ type: `setMake`, data: { index, value } }),
      }),
    [entry, index, dispatch]
  )
  const Model = useMemo(
    () =>
      generateManuallyResolveFleetEntryDropdown({
        name: `model`,
        dataTestId: MANUALLY_RESOLVE_ENTRY_FIELDS_DATA_TEST_IDS.MODEL,
        entry,
        dataKey: `models`,
        prerequisiteFields: [`make`],
        onChange: (value) => dispatch({ type: `setModel`, data: { index, value } }),
      }),
    [entry, index, dispatch]
  )
  const Fuel = useMemo(
    () =>
      generateManuallyResolveFleetEntryDropdown({
        name: `fuelType`,
        dataTestId: MANUALLY_RESOLVE_ENTRY_FIELDS_DATA_TEST_IDS.FUEL,
        entry,
        dataKey: `fuelTypes`,
        prerequisiteFields: [`make`, `model`],
        onChange: (value) => dispatch({ type: `setFuelType`, data: { index, value } }),
      }),
    [entry, index, dispatch]
  )
  const Confirm = useMemo(
    () =>
      generateManuallyResolveFleetEntryConfirm({
        dataTestId: MANUALLY_RESOLVE_ENTRY_FIELDS_DATA_TEST_IDS.CONFIRM,
        entry,
        onConfirmed: (vehicle: FilterVehicle) => dispatch({ type: `setVehicle`, data: { index, value: vehicle } }),
      }),
    [entry, index, dispatch]
  )
  return {
    Make,
    Model,
    Fuel,
    Confirm,
  }
}
